import React from 'react';
import { Navbar, Nav, Container, Button, NavDropdown } from 'react-bootstrap';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import './Navigation.css';

const Navigation = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const isActive = (path) => {
    return location.pathname === path;
  };
  return (
    <Navbar bg="dark" variant="dark" expand="lg" className="py-3 shadow-sm" fixed="top">
      <Container>
        <Navbar.Brand as={Link} to="/" className="d-flex align-items-center">
          <img
            src={require('../assets/lkk_logo.png')}
            alt="LKK Tech Solutions Logo"
            height="56"
            className="me-2"
            style={{ objectFit: 'contain', maxWidth: '220px' }}
          />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="mx-auto align-items-lg-center">
            <Nav.Link 
              as={Link} 
              to="/" 
              className={`px-3 nav-link-animated ${isActive('/') ? 'active' : ''}`}
            >
              Home
            </Nav.Link>
            <Nav.Link 
              as={Link} 
              to="/services" 
              className={`px-3 nav-link-animated ${isActive('/services') ? 'active' : ''}`}
            >
              Services
            </Nav.Link>
            <NavDropdown 
              title="Products" 
              id="products-nav-dropdown"
              className={`px-3 nav-link-animated ${location.pathname.startsWith('/product') ? 'active' : ''}`}
              onClick={(e) => {
                // If user clicks on the main "Products" toggle text on desktop/mobile, navigate to /products
                if (e.target && e.target.classList.contains('dropdown-toggle')) {
                  navigate('/products');
                }
              }}
            >
              <NavDropdown.Item as={Link} to="/products" className="fw-semibold">
                <i className="bi bi-grid-fill me-2 text-info"></i>Overview (All Products)
              </NavDropdown.Item>
              <NavDropdown.Divider />
              <NavDropdown.Item as={Link} to="/products/parkgenie">
                <i className="bi bi-car-front-fill me-2 text-primary"></i>ParkGenie - PMS
              </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/products/finvecto">
                <i className="bi bi-calculator me-2 text-success"></i>Finvecto - Accounting
              </NavDropdown.Item>
            </NavDropdown>
            <Nav.Link 
              as={Link} 
              to="/portfolio" 
              className={`px-3 nav-link-animated ${isActive('/portfolio') ? 'active' : ''}`}
            >
              Portfolio
            </Nav.Link>
            <Nav.Link 
              as={Link} 
              to="/testimonials" 
              className={`px-3 nav-link-animated ${isActive('/testimonials') ? 'active' : ''}`}
            >
              Testimonials
            </Nav.Link>
            <Nav.Link 
              as={Link} 
              to="/blogs" 
              className={`px-3 nav-link-animated ${location.pathname.startsWith('/blogs') ? 'active' : ''}`}
            >
              Blog
            </Nav.Link>
            <Nav.Link 
              as={Link} 
              to="/careers" 
              className={`px-3 nav-link-animated ${isActive('/careers') ? 'active' : ''}`}
            >
              Careers
            </Nav.Link>
            <Nav.Link 
              as={Link} 
              to="/contact" 
              className={`px-3 nav-link-animated ${isActive('/contact') ? 'active' : ''}`}
            >
              Contact
            </Nav.Link>
          </Nav>
          <Nav>
            <Button
              variant="primary"
              className="px-4 py-2"
              style={{ borderRadius: '4px' }}
              onClick={() => {
                navigate('/#contact');
                // For smooth scroll if already on home
                setTimeout(() => {
                  const el = document.getElementById('contact');
                  if (el) el.scrollIntoView({ behavior: 'smooth' });
                }, 100);
              }}
            >
              Get started
            </Button>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Navigation;
